<template>
  <div>
    <div style="display: flex;" class="fob-only-for-print-view fob-entity-list-options">
      <div>
        <transition name="tags">
          <b-field class="fob-entity-list-filter-tags fob-entity-list-options-tag-list-static" grouped group-multiline>
            <div style="display: flex; flex-flow: row wrap; align-content: space-between;">
              <div v-for="(value, field) in activeFilter" :key="field">
                <b-taglist v-if="value && value.length > 0" attached>
                  <b-tag type="is-aquamarine">
                    {{ $gettext(labelForActiveFilterField(field)) }}
                  </b-tag>
                  <b-tag type="is-basalt">
                    {{ $gettext(labelForActiveFilterValue(field, value)) }}
                  </b-tag>
                </b-taglist>
              </div>
            </div>
          </b-field>
        </transition>
      </div>
      <div>
        <div class="print-metadata-box">
          <div class="print-metadata-columns">
            <div class="print-metadata-label"><translate>tag.static.printedPageOfPagesLabel</translate></div>
            <div class="print-metadata-value"><translate :translate-params="{page, totalTablePages}">tag.static.printedPageOfPagesValue</translate></div>
          </div>
          <div class="print-metadata-columns">
            <div class="print-metadata-label"><translate>tag.static.resultCount</translate></div>
            <div class="print-metadata-value">{{total[resourceType]}}</div>
          </div>
          <div class="print-metadata-columns">
            <div class="print-metadata-label"><translate>tag.static.entriesPerPage</translate></div>
            <div class="print-metadata-value">{{config[resourceType].perPage}}</div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="fob-hide-in-print"
      style="display: flex; margin-bottom: 15px; align-items: center;"
    >
      <!-- RESEARCH ACTIVITIY | Per page -->
      <div style="display:flex; align-items: center;">
        <b-icon
          class="has-text-aquamarine"
          style="margin-right: 10px;"
          pack="fa"
          icon="list-ul"
        ></b-icon>
        <b-select
          v-model="config[resourceType].perPage"
          @input="onPerPageChange"
          style="margin-right: 0px;"
        >
          <option value="5">5 <translate>list.header.perPage</translate></option>
          <option value="10">10 <translate>list.header.perPage</translate></option>
          <option value="15">15 <translate>list.header.perPage</translate></option>
          <option value="20">20 <translate>list.header.perPage</translate></option>
          <option value="100">100 <translate>list.header.perPage</translate></option>
        </b-select>
      </div>
      <!-- RESEARCH ACTIVITIY | Sorting -->
      <fob-aboutme-list-sort
        :key="resourceType"
        :resourceType="resourceType"
        :sortOrder="config[resourceType].sortOrder"
        :sortField="config[resourceType].sortField"
        :sortFields="config[resourceType].sortFields"
        @update:sortOrderAboutMe="onUpdateSortOrder"
        @update:sortFieldAboutMe="onUpdateSortField"
      ></fob-aboutme-list-sort>
    </div>
    <div
      class="fob-hide-in-print"
      style="display: flex; margin-bottom: 15px; align-items: center;"
    >
      <!-- RESEARCH ACTIVITIY | Filters -->
      <fob-aboutme-list-filter :resourceType="resourceType"></fob-aboutme-list-filter>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import AboutMeListSort from '@/components/aboutme/AboutMeListSort'
import AboutMeListFilter from '@/components/aboutme/AboutMeListFilter'
import AboutMeHelper from '@/components/mixins/AboutMeHelper'

export default {
  name: 'fob-aboutme-list-options',
  props: ['resourceType'],
  mixins: [AboutMeHelper],
  computed: {
    ...mapGetters({
      config: 'aboutme/getConfig',
      total: 'aboutme/getTotal',
      filter: 'aboutme/getFilter'
    }),
    activeFilter () {
      return this.filter[this.activeResourceType].filter
    },
    page () {
      return this.config[this.activeResourceType].page
    },
    totalTablePages () {
      return Math.ceil(this.total[this.activeResourceType] / this.config[this.activeResourceType].perPage)
    }
  },
  methods: {
    onPerPageChange (perPage) {
      this.$store.dispatch('aboutme/changePerPage', {
        resourceType: this.activeResourceType,
        perPage
      }).then(() => {
        this.loadAsyncData()
      })
    },
    labelForActiveFilterField (filterField) {
      return this.filter[this.activeResourceType].filters.find(filter => {
        return filter.value === filterField
      }).label
    },
    labelForActiveFilterValue (filterField, filterValue) {
      let filterConfig = this.filter[this.activeResourceType].filters.find(filter => {
        return filter.value === filterField
      })
      if (filterConfig.type === 'select') {
        return `AboutMe.filter.${filterField}.${filterValue.toLowerCase()}`
      } else {
        return filterValue
      }
    },
    onUpdateSortField (sortField) {
      this.$store.dispatch('aboutme/setSortField', {
        resourceType: this.resourceType,
        sortField
      }).then(() => {
        this.loadAsyncData()
      })
    },
    onUpdateSortOrder (sortOrder) {
      this.$store.dispatch('aboutme/setSortOrder', {
        resourceType: this.resourceType,
        sortOrder
      }).then(() => {
        this.loadAsyncData()
      })
    }
  },
  components: {
    'fob-aboutme-list-sort': AboutMeListSort,
    'fob-aboutme-list-filter': AboutMeListFilter
  }
}

</script>

<style lang="scss">

  .print-metadata-box {
    width: 275px;
    border: black solid 1px;
    border-radius: 2px;
    font-size: 10px !important;
    position: absolute;
    right: 0px;
    top: 0px;

    .print-metadata-columns {
      display: flex;
      justify-content: flex-end;
      margin-left: 5px;

      .print-metadata-label {
        flex: none;
        padding: 0px;
        width: 70%;
      }

      .print-metadata-value {
        display: block;
        flex-basis: 0;
        flex-shrink: 1;
        flex-grow: 1;
        padding: 0px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/aboutme/AboutMeListOptions.vue